import {Member, Order} from 'aigens-ng-core';

declare var genkiJSInterface: any;
export class NetspayManager {
    constructor() {
        NetspayManager._this = this;

    }
    /*
    apikey: "fa9b51d6-412f-4f4c-87e3-92b9ce3a4084"
    dev:
    secrets:
    secret: "9905c100-c94f-4327-afd5-4d8f818062f2"
    gateway: "nets"
    id: "Payment-800001-creditcard-nets"
    method: "creditcard"
    type: "payment"
    umid: "UMID_877767002"
    */

    static _this: NetspayManager;

    // attri
    bkMember: Member;
    order: Order;
    netspayCharge: any;

    pay(handlingFunction, netspayManagerCallback?) {

        handlingFunction(netspayManagerCallback, this.callNetspayAPP, this.errorCallback);
        // if (!this.isValidPickupTime()) {
        //     if (netspayManagerCallback) {
        //         this.errorCallback(netspayManagerCallback);
        //     }
        //     return;
        // }

        // this.orderService.email = this.bkMember.email;
        // this.orderService.phone = this.bkMember.phone;

        // this.loading(true);
        // this.monitoringService.listenStoreKioskStatus(this.orderManager.store, () => {
        //     this.loading(false);
        //     this.showAlert("", this.t.instant("global.kiosk-offline-message"), [{
        //         text: this.t.instant("buttons.ok"),
        //         handler: () => {
        //             if (this.orderManager.mode == "delivery") {
        //                 this.popToRoot();
        //             } else {
        //                 if (genkiJSInterface.exitwebview) {
        //                     genkiJSInterface.exitwebview();
        //                 }
        //             }
        //         }
        //     }]);

        //     if (netspayManagerCallback) {
        //         this.errorCallback(netspayManagerCallback);
        //     }
        // }, () => { // pay

        //     this.modifierItemHandling(this.order);
        //     if (this.orderManager.mode == "delivery") {
        //         var today = new Date().getTime() + 10 * 60000
        //         var timelabel = this.timeStringLabel(today);
        //         var pickedTime = this.getDateStringLabel(today) + "T" + timelabel + ":00.000"
        //         this.orderService.pickUpTime = pickedTime;
        //     }
        //     this.orderService.postBKOrder(this.order, this.netspayCharge,true).subscribe(orders => {
        //         this.loading(false);
        //         console.log('jadd orders:', orders);
        //         this.callNetspayAPP(netspayManagerCallback, orders);

        //     }, err => {
        //         this.loading(false);
        //         if (err.status == 401) {
        //             if (this.browserService.isBKApp()) {
        //                 if (genkiJSInterface.setSessionExpire) {
        //                     genkiJSInterface.setSessionExpire(true);
        //                 }

        //                 if (genkiJSInterface.hasAlert) {
        //                     genkiJSInterface.hasAlert(true);
        //                 }
        //             }

        //             var alert = this.showAlert(err.status, err["_body"], [{
        //                 text: this.t.instant("buttons.ok"),
        //                 handler: () => {
        //                     if (genkiJSInterface.exitwebview) {
        //                         genkiJSInterface.exitwebview();
        //                     }

        //                 }
        //             }]);

        //             alert.onDidDismiss(() => {
        //                 if (genkiJSInterface.hasAlert) {
        //                     genkiJSInterface.hasAlert(false);
        //                 }
        //             });
        //         } else {
        //             this.showError(err);
        //         }
        //         if (netspayManagerCallback) {
        //             this.errorCallback(netspayManagerCallback);
        //         }
        //     })

        // })
    }

    callNetspayAPP(netspayManagerCallback, order) {
        const callbackReuslt = { 'result': 1 };


        const requestPayCallback = 'requestPayCallback';
        window[requestPayCallback] = function (value) {

            console.log('requestPayCallback ', value);
            if (!value['result']) { // faild
                NetspayManager._this.errorCallback(netspayManagerCallback, value);
            } else {  // success
                callbackReuslt['order'] = order;
                netspayManagerCallback(callbackReuslt);
            }

        };
        let params = {};

        if (order && order['extra'] && order['extra']['apikey'] && order['extra']['hmac'] && order['extra']['txnReq']) {
            params['apiKey'] = order['extra']['apikey'];
            params['txnReq'] = order['extra']['txnReq'];
            params['hmac'] = order['extra']['hmac'];

            try {
                params = JSON.stringify(params);
                (<any>window).genkiJSInterface.requestPay(params, requestPayCallback);
            } catch (error) {
                console.log('genkiJSInterface error requestPay');
                this.errorCallback(netspayManagerCallback, { 'desc': 'genkiJSInterface error requestPay', 'error': error });
            }
        } else {
            console.log('miss params');

        }


    }

    /// pararms : { }
    errorCallback(netspayManagerCallback: any, pararms?) {
        if (pararms) {
            pararms['result'] = 0;
        } else {
            pararms = { 'result': 0 };
        }
        netspayManagerCallback(pararms);
    }

}
